module.exports = __webpack_public_path__ + "img/primitive-man.d9c3dee0.svg";